// actions
const actions = {
  event: ({ dispatch }, params) => {
    dispatch('fbqTrack', params);
    dispatch('gtagEvent', params);
  },
  fbqTrack: ({}, { event, p }) => {
    if (window.fbq) {
      window.fbq('track', event, p);
    } else {
      console.log('local fbq');
      console.log(event, p);
    }
  },
  gtagEvent: ({}, { event, p }) => {
    !function () {
      if (window.dataLayer) {
        window.dataLayer.push(arguments);
      } else {
        console.log('local gtag');
        console.log(arguments);
      }
    }('event', event, p);
  },
  appsflyer: ({}, event) => {
    if (window.AF) {
      window.AF('pba', 'event', event);
    } else {
      console.log('local AF');
      console.log(event);
    }
  }
};

export default {
  namespaced: true,
  actions,
};
